export const authUser = (state, authData) => {
  state.apiKey = authData.token;
  state.userId = authData.id;
  state.userConfig = authData.config;
  state.agentId = authData.agentId;
  state.itineraryAgentId = authData.agentId;
  state.itineraryAgentName = authData.agentName;
  state.itineraryAgentCurrency = authData.itineraryAgentCurrency;
  state.itineraryDepartment = authData.config.department;
};
export const clearAuthData = (state) => {
  state.apiKey = null;
  state.userId = null;
  state.userConfig = null;
  state.agentId = null;
  state.itineraryAgentId = null;
  state.itineraryDepartment = null;
};
export const updateAppSnackbar = (state, snackOptions) => {
  state.appSnackbar = { ...snackOptions };
};
export const updateLocalSettings = (state, payload) => {
  state.localSettings = { ...state.localSettings, ...payload };
};
export const updateItineraryAgent = (state, payload) => {
  state.itineraryAgentId = payload;
};
export const updateItineraryAgentName = (state, payload) => {
  state.itineraryAgentName = payload;
};
export const updateItineraryAgentCurrency = (state, payload) => {
  state.itineraryAgentCurrency = payload;
};
export const updateItineraryAgentDepartment = (state, payload) => {
  state.itineraryAgentDepartment = payload;
};
export const updateItineraryDepartment = (state, payload) => {
  state.itineraryDepartment = payload;
};
export const updateAppToolbarInfo = (state, payload) => {
  state.appToolbarInfo = payload;
};
export const updateInactivityTime = (state, payload) => {
  state.inactivityTime = payload;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js